import React, { useEffect } from 'react';
import './SuccessModal.css';
import { popoverContainerStyle, popoverMessageStyle } from './PopoverStyles';

/**
 * Shared Success Modal Component
 * Shows an icon and message, auto-closes after timeout
 *
 * @param {boolean} isOpen - Whether the modal is open
 * @param {Function} onClose - Close callback
 * @param {string} message - Message to display
 * @param {number} autoCloseMs - Auto-close timeout in milliseconds (default: 3000)
 * @param {string} variant - Icon variant: 'success' (green checkmark) or 'warning' (yellow exclamation)
 */
const SuccessModal = ({
  isOpen,
  onClose,
  message,
  autoCloseMs = 3000,
  variant = 'success'
}) => {
  // Auto-close after timeout
  useEffect(() => {
    if (isOpen && autoCloseMs > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseMs);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoCloseMs, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay success-modal-overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={message}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ ...popoverContainerStyle, textAlign: 'center' }}
        className="success-modal-content"
      >
        <div className={`success-modal-icon ${variant === 'warning' ? 'success-modal-icon--warning' : ''}`} aria-hidden="true">
          {variant === 'warning' ? '!' : '✓'}
        </div>
        <p style={popoverMessageStyle}>{message}</p>
      </div>
    </div>
  );
};

export default SuccessModal;
